import { render, staticRenderFns } from "./BaseLoadingPage.vue?vue&type=template&id=65dbf0f6&scoped=true"
import script from "./BaseLoadingPage.vue?vue&type=script&lang=js"
export * from "./BaseLoadingPage.vue?vue&type=script&lang=js"
import style0 from "./BaseLoadingPage.vue?vue&type=style&index=0&id=65dbf0f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dbf0f6",
  null
  
)

export default component.exports